/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Button, Segment, Dimmer, Loader } from 'semantic-ui-react';
import { FormControlLabel, Checkbox, TextField } from '@mui/material';
import '../App.css';
import { useToasts } from 'react-toast-notifications';
import { useDispatch, useSelector } from 'react-redux';
import { changeBrowserTabTitle } from '../slices/browserTabTitle/browserTabTitleSlice';
import { useNavigate } from 'react-router-dom';
import {
    selectCurrentUserName, selectCurrentUserNotificationEmail,
    selectCurrentUserAdditionalEmail, selectCurrentUserShortBio, selectCurrentUserAffiliations,
    selectCurrentUserTermsOfUseAccepted, selectCurrentUserDataPersonalAgreementAccepted,
    selectDisplayTheTermsOfAgreement,
    selectCurrentUserIdToken,
    selectCurrentUserApiToken
} from '../slices/currentUser/currentUserSlice';
import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];
//Updates the user's personal info on the server
const updateUserAccountAPI = async (idToken = null, userState = null) => {
    if (!idToken) {
        console.log("no idToken");
        return null;
    }
    if (!userState) {
        console.log("no userState");
        return null;
    }
    //console.log("CALLING SERVER with updateuser")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'updateuser',
            idToken: idToken,
            name: userState.name,
            shortbio: userState.shortbio,
            notificationemail: userState.notificationemail,
            additionalemail: userState.additionalemail,
            affiliations: userState.affiliations
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from updateuser call");
    }).catch((error) => { console.log(error); });
};


const updateUserAccount = async (idToken, userState) => {

    let loadedData = await updateUserAccountAPI(idToken, userState);
    if (loadedData.success) {
        loadedData.loading = false;
        loadedData.idToken = userState.idToken;
        //TODO -- reload/change currentUserSlice data if necessary  
    } else {
        //throw new Error("error");
        return false;
    }
    return loadedData;
}

const updateUserAccountWithUserProfile = async (addToast, idToken, userProfileState,
    navigate, redirect) => {
    let success = false;
    if (userProfileState.notificationemail && !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userProfileState.notificationemail))) {
        alert("The notification email address is not valid.");
        return false;
    }

    if (userProfileState.additionalemail?.trim() && !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userProfileState.additionalemail))) {
        alert("The backup email address is not valid.");
        return false;
    }

    let response = await updateUserAccount(idToken, userProfileState);

    if (response && response !== "error") {
        success = true;
        if (redirect !== undefined) {
            navigate(redirect);
        }
        addToast('Updated Profile', { appearance: 'success' });
    } else {
        console.log("ERROR!!!!: " + response);
        addToast('Error, could not update user profile', { appearance: 'error' });
    }
    return success;
}

const ifStateElementIsNotNewValueThenSetIt = (state, element, newValue, setState) => {
    if (state[element] !== newValue) {
        setState(prevState => {
            return { ...prevState, [element]: newValue };
        })
    }
};

const EditUserProfileTextFields = ({ userState, setUserState }) => {

    return <>
        <h3>Edit User Profile {userState.name && <>({userState.name})</>}</h3>
        <span style={{ marginLeft: "20px" }}>
            <br />
            <TextField style={{ width: "400px" }} className="inputField" type='text'
                label='Display Name' size="small" variant='outlined'
                value={userState.name || ''}
                onChange={(e) => { ifStateElementIsNotNewValueThenSetIt(userState, "name", e.target.value, setUserState); }} />
            <br /><br />
            <TextField style={{ width: "460px" }} className="inputField" type='text'
                label='Email for Notifications' size="small" variant='outlined'
                value={userState.notificationemail || ''}
                onChange={(e) => { ifStateElementIsNotNewValueThenSetIt(userState, "notificationemail", e.target.value, setUserState); }} />
            <br /><br />
            <TextField style={{ width: "460px" }} className="inputField" type='text'
                label='Backup Email' size="small" variant='outlined'
                value={userState.additionalemail || ''}
                onChange={(e) => { ifStateElementIsNotNewValueThenSetIt(userState, "additionalemail", e.target.value, setUserState); }} />
            <br /><br />
            <TextField style={{ width: "460px" }} className="inputField" type='text'
                label='Personal Tagline' size="small" variant='outlined'
                value={userState.shortbio || ''}
                onChange={(e) => { ifStateElementIsNotNewValueThenSetIt(userState, "shortbio", e.target.value, setUserState); }} />
            <br /><br />
            {userState.affiliations.map((affiliation, index) => {
                return <span key={index}>
                    <TextField style={{ width: "400px" }} key={index} className="inputField" type='text'
                        label={'Affiliation ' + (index + 1)} size="small" variant='outlined'
                        value={affiliation}
                        onChange={(e) => {
                            setUserState(prevState => {
                                let prevAffiliations = [...prevState["affiliations"]];
                                prevAffiliations[index] = e.target.value;
                                return {
                                    ...prevState,
                                    affiliations: prevAffiliations,
                                };
                            });
                        }}
                        autoFocus={!userState.startLoad} />
                    &nbsp;&nbsp;&nbsp;
                    <Button className="formButton negative" content="✖" compact
                        onClick={() => {
                            setUserState(prevState => {
                                let prevAffiliations = [...prevState["affiliations"]];
                                prevAffiliations.splice(index, 1);
                                return {
                                    ...prevState,
                                    affiliations: prevAffiliations,
                                };
                            });
                        }} />
                    <br /><br />
                </span>
            })}
            <span style={{ height: "0px" }}> </span>
            <span style={{ paddingLeft: "320px" }}>
                <Button className="formButton" style={{ color: "#000000" }}
                    content="+ Add Another Affiliation" compact
                    onClick={() => {
                        ifStateElementIsNotNewValueThenSetIt(userState, "startLoad", false, setUserState);
                        setUserState(prevState => {
                            let prevAffiliations = [...prevState["affiliations"]];
                            prevAffiliations.push("");
                            return {
                                ...prevState,
                                affiliations: prevAffiliations
                            };
                        });

                    }} />
            </span>
        </span>
    </>;
};

const EditUserProfilePage = ({ setAlertModalState }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const idToken = useSelector(selectCurrentUserIdToken);
    const apiToken = useSelector(selectCurrentUserApiToken);
    const userName = useSelector(selectCurrentUserName);
    const notificationEmail = useSelector(selectCurrentUserNotificationEmail);
    const additionalEmail = useSelector(selectCurrentUserAdditionalEmail);
    const shortBio = useSelector(selectCurrentUserShortBio);
    const affiliations = useSelector(selectCurrentUserAffiliations);
    const termsOfUseAccepted = useSelector(selectCurrentUserTermsOfUseAccepted);
    const dataPersonalAgreementAccepted = useSelector(selectCurrentUserDataPersonalAgreementAccepted);
    const displayTheTermsOfAgreement = useSelector(selectDisplayTheTermsOfAgreement);

    const [userProfileState, setUserProfileState] = useState({
        loading: true,
        startLoad: true,
        name: '',
        notificationemail: '',
        additionalemail: '',
        shortbio: '',
        affiliations: [""],
        termsofuseacceptCheckbox: true,
        datapersonalagreementacceptCheckbox: true
    });
    const [showApiTokenState, setShowApiTokenState] = useState(false);

    const { addToast } = useToasts();

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Edit User Profile"));
        setUserProfileState({
            loading: false,
            startLoad: true,
            name: userName,
            notificationemail: notificationEmail,
            additionalemail: additionalEmail,
            shortbio: shortBio,
            affiliations: affiliations || [""],
            termsofuseacceptCheckbox: termsOfUseAccepted,
            datapersonalagreementacceptCheckbox: dataPersonalAgreementAccepted,
            displaythetermsofagreement: displayTheTermsOfAgreement
        });
    }, []);

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            {
                userProfileState.loading
                &&
                <Dimmer className={"loadingDimmer"} active inverted>
                    <Loader inverted>Loading</Loader>
                </Dimmer>
            }
            {idToken ?
                <>
                    <EditUserProfileTextFields userState={userProfileState} setUserState={setUserProfileState} />
                    <br /><br />
                    <FormControlLabel
                        style={{ pointerEvents: "none" }}
                        control={<Checkbox style={{ pointerEvents: "auto" }}
                            name="termsofuseaccept" inputProps={{ 'aria-label': 'Agree to the Terms of Use' }}
                            color="primary" checked={userProfileState.termsofuseacceptCheckbox}
                            onChange={(e) => {
                                if (userProfileState.termsofuseacceptCheckbox) {
                                    if (window.confirm("Do you want to be removed from the FEvIR Platform?")) {
                                        setUserProfileState(prevState => {
                                            return { ...prevState, "termsofuseacceptCheckbox": false }
                                        });
                                        navigate("/userremoval");
                                    } else {
                                        setUserProfileState(prevState => {
                                            return { ...prevState, "termsofuseacceptCheckbox": true }
                                        });
                                    }
                                } else {
                                    setUserProfileState(prevState => {
                                        return { ...prevState, "termsofuseacceptCheckbox": true }
                                    });
                                }
                            }} />}
                        label={<span>I agree to the <a href="/termsofuse" target="_blank"
                            rel="noopener noreferrer"
                            style={{ pointerEvents: "auto" }}>Acceptable Use Policy</a> (Uncheck to be removed from the FEvIR Platform.)</span>}
                    />
                    <br />
                    <FormControlLabel
                        style={{ pointerEvents: "none" }}
                        control={<Checkbox style={{ pointerEvents: "auto" }}
                            name="datapersonalagreementaccept"
                            inputProps={{ 'aria-label': 'Agree to the Personal Data Agreement Terms' }}
                            color="primary"
                            checked={userProfileState.datapersonalagreementacceptCheckbox}
                            onChange={(e) => {
                                if (userProfileState.datapersonalagreementacceptCheckbox) {
                                    if (window.confirm("Do you want to be removed from the FEvIR Platform?")) {
                                        setUserProfileState(prevState => {
                                            return { ...prevState, "datapersonalagreementacceptCheckbox": false }
                                        });
                                        navigate("/userremoval");
                                    } else {
                                        setUserProfileState(prevState => {
                                            return { ...prevState, "datapersonalagreementacceptCheckbox": true }
                                        });
                                    }
                                } else {

                                    setUserProfileState(prevState => {
                                        return { ...prevState, "datapersonalagreementacceptCheckbox": true }
                                    });
                                }
                            }} />}
                        label={<span>I agree to the <a href="/personaldataagreement" target="_blank"
                            rel="noopener noreferrer"
                            style={{ pointerEvents: "auto" }}>Privacy Policy Agreement</a> (Uncheck to be removed from the FEvIR Platform.)</span>}
                    />
                    <br /><br />
                    <Button className="formButton positive" content="Update Profile" compact
                        onClick={() => {
                            if (userProfileState.name.trim()) {
                                updateUserAccountWithUserProfile(addToast, idToken, userProfileState, navigate, "/");
                            } else {
                                setAlertModalState(prevState => {
                                    return {
                                        ...prevState,
                                        "open": true,
                                        "header": "Error",
                                        "content": "Please enter your name."
                                    };
                                });
                            }
                        }} />
                    <span style={{ marginLeft: "10px" }}>
                    </span>
                </>
                :
                <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
            }
            <Button className="formButton negative" content="Cancel"
                onClick={() => {
                    setUserProfileState(prevState => {
                        return { ...prevState, "loading": true };
                    });
                    navigate("/");
                }} compact />

            <br /><br /><br /><br />
            {apiToken && <>
                <div style={{ fontSize: "16px" }}>FEvIR API Token {showApiTokenState === true ?
                    <span style={{
                        fontSize: "12px", marginLeft: "12px",
                        padding: "4px 8px 4px 8px", border: "1px black solid"
                    }}>{apiToken}</span>
                    :
                    <Button className="formButton" style={{ color: "#000000" }}
                        content="Show My FEvIR API Token" compact
                        onClick={() => { setShowApiTokenState(true); }} />
                }
                </div>
                <br /><br />
            </>}
        </Segment>
    </div>;
};

export default EditUserProfilePage;